let mobileMenuLoaded = false

class MobileMenu extends window.BAO.CustomElement() {
  connectedCallback () {
    if (mobileMenuLoaded) return

    window.BAO.sectionRenderer
      .fetch('drawers-navigation', '/?view=mobile-menu')
      .then(res => {
        mobileMenuLoaded = true

        const newDOM = window.BAO.sectionRenderer.convertToDOM(
          res['drawers-navigation'],
        )
        const myself = newDOM.querySelector(this.localName)

        this.outerHTML = myself.outerHTML

        window.BAO.dispatchEvent(window.BAO.EVENTS.MOBILE_MENU.RENDERED)
      })
      .catch(() => {})
  }
}

if (!customElements.get('mobile-menu')) {
  customElements.define('mobile-menu', MobileMenu)
}
